export const PRICES_MAIN = {
  image: '/assets/prices/wedding-lux.jpg',
  category: 'Свадебная',
  title: 'Полный день ЛЮКС (12 часов)',
  features: [
    { text: 'Утро невесты — съемка до росписи — роспись — прогулочная фотосессия — съемка банкета' },
    { text: 'Отобранные исходные кадры в цветокоррекции (300+)' },
    { text: '60 фото в ретуши' },
    { text: 'Помощь в подборе локации' },
    { text: 'Срок получения всех фотографий до 20 дней (10 анонс-кадров день в день)' },
    { text: '2 видео-reels до 1 минуты' },
    { text: 'Бэкстэйдж со съемки' },
    { text: 'Закрытый доступ к фотографиям на облачном диске' },
  ],
  price: '70 000р',
  disclaimer: '*Визажист и стилист по запросу',
};

export const PRICES_CARDS = [
  {
    image: '/assets/prices/base.jpg',
    category: 'Индивидуальная',
    title: 'БАЗА (1 час)',
    features: [
      { text: 'Отобранные исходные кадры в цветокоррекции (60+)' },
      { text: '20 фото в ретуши' },
      { text: 'Помощь в подборе локации (студии)' },
      { text: 'Срок получения всех фотографий 3–7 дней' },
      { text: 'Закрытый доступ к фотографиям на облачном диске' },
    ],
    price: '7 000р',
    disclaimer: '*оплата фотостудии и визажиста отдельно',
  },
  {
    image: '/assets/prices/premium.jpg',
    category: 'Индивидуальная',
    title: 'ПРЕМИУМ (2 часа)',
    features: [
      { text: 'Отобранные кадры в цветокоррекции (100+)' },
      { text: '25 фото в ретуши' },
      { text: 'Помощь в подборе локации (студии)' },
      { text: 'Срок получения фотографий до 7 дней' },
      { text: 'Успеваем отснять 3 образа' },
      { text: 'Визажист (полный образ — макияж и укладка)' },
      { text: 'Фотостудия и гримерная (для визажиста)' },
      { text: 'Сопровождение визажиста на всю съемку (смена образа)' },
      { text: 'Закрытый доступ к фотографиям на облачном диске' },
    ],
    price: '25 000р',
  },
  {
    image: '/assets/prices/lux.jpg',
    category: 'Индивидуальная',
    title: 'ЛЮКС (2 часа)',
    features: [
      { text: 'Отобранные кадры в цветокоррекции (100+)' },
      { text: '25 фото в ретуши' },
      { text: 'Видео-reels до 35 секунд' },
      { text: 'Бэкстэйдж со съемки' },
      { text: 'Помощь в подборе локации (студии)' },
      { text: 'Срок получения фотографий до 7 дней' },
      { text: 'Успеваем отснять 3 образа' },
      { text: 'Визажист (полный образ — макияж и укладка)' },
      { text: 'Фотостудия и гримерная (для визажиста)' },
      { text: '2 персональных образа от стилиста' },
      { text: 'Сопровождение визажиста на всю съемку (смена образа)' },
    ],
    price: '35 000р',
  },
  {
    image: '/assets/prices/wedding-ultra.jpg',
    category: 'Свадебная',
    title: 'Роспись УЛЬТРА (3 и более часов)',
    features: [
      { text: 'Съемка до росписи — роспись — прогулочная фотосессия — съемка банкета' },
      { text: 'Отобранные исходные кадры в цветокоррекции (100+)' },
      { text: '40 фото в ретуши' },
      { text: 'Помощь в подборе локации' },
      { text: 'Срок получения всех фотографий до 10 дней (10 анонс-кадров день в день)' },
      { text: 'Видео-reels до 1 минуты' },
      { text: 'Бэкстэйдж со съемки' },
      { text: 'Закрытый доступ к фотографиям на облачном диске' },
    ],
    price: '25 000р',
    extraNote: 'каждый доп. час +6 000р',
    disclaimer: '*Визажист и стилист по запросу',
  },
];
